import {useCallback, useState} from "react";
import {platformAPI} from "../../../api/axiosConfig";
import {isAxiosError} from "axios";
import {SirenEmailBranding} from "./useGetSirenEmailBrandings";
import {useEvents} from "../../../lib/useEvents";

export type SirenEmailBrandingInput = {
    clientID?: string;
    departmentID?: string;
    theme: string;
    customCSS: string;
    footerText: string;
    sirenRecipientPortalURL: string;
};

export function useUpsertSirenEmailBranding() {
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const {emit} = useEvents();

    const save = useCallback(async (input: SirenEmailBrandingInput, id?: string): Promise<SirenEmailBranding> => {
        setSaving(true);
        setError(null);
        try {
            let result: SirenEmailBranding;
            if (id) {
                const res = await platformAPI.patch<SirenEmailBranding>(`api/siren/email-branding/${id}`, input);
                result = res.data;
            } else {
                const res = await platformAPI.post<SirenEmailBranding>("api/siren/email-branding", input);
                result = res.data;
            }
            emit("siren:emailBranding:changed", {clientID: input.clientID, departmentID: input.departmentID || undefined});
            return result;
        } catch (e) {
            if (isAxiosError(e) && e?.response?.data?.error) {
                setError(e.response.data.error);
            } else {
                setError("Failed to save siren email branding");
            }
            throw e;
        } finally {
            setSaving(false);
        }
    }, [emit]);

    return {save, saving, error};
}
